import _ from 'underscore';

_.mixin({
  repeat: function (func, interval) {
    var args = _.last(arguments, 2);
    var timerId = setInterval(_.bind(func, null, args), interval);

    return function () {
      clearInterval(timerId);
    };
  }
});

_.mixin({
  delayed: function (func, interval) {
    var args = _.last(arguments, 2);
    var timerId = setTimeout(_.bind(func, null, args), interval);

    return function () {
      clearTimeout(timerId);
    };
  }
});
